import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FontSizeDirective } from '@egret/shared/directives/font-size.directive';
import { ScrollToDirective } from '@egret/shared/directives/scroll-to.directive';
import { AppDropdownDirective } from '@egret/shared/directives/dropdown.directive';
import { DropdownAnchorDirective } from '@egret/shared/directives/dropdown-anchor.directive';
import { DropdownLinkDirective } from '@egret/shared/directives/dropdown-link.directive';
import { EgretSideNavToggleDirective } from '@egret/shared/directives/egret-side-nav-toggle.directive';
import { EgretSidenavHelperDirective, EgretSidenavTogglerDirective } from '@egret/shared/directives/egret-sidenav-helper/egret-sidenav-helper.directive';

import { ColumnTemplateDirective } from 'bookraw/shared/directives/column-template.directive';
import { ToolbarInjectorDirective } from 'bookraw/shared/directives/toolbar-injector.directive';
import { DefaultImageDirective } from './default-image.directive';
import { RequirePermissionDirective } from 'bookraw/shared/directives/require-permission.directive';
import { RequireFeatureDirective } from 'bookraw/shared/directives/require-feature.directive';
import { StatisticsPercentDirective } from './statistics-percent.directive';

const directives = [
  FontSizeDirective,
  ScrollToDirective,
  AppDropdownDirective,
  DropdownAnchorDirective,
  DropdownLinkDirective,
  EgretSideNavToggleDirective,
  EgretSidenavHelperDirective,
  EgretSidenavTogglerDirective,
  ColumnTemplateDirective,
  ToolbarInjectorDirective,
  DefaultImageDirective,
  RequirePermissionDirective,
  RequireFeatureDirective,
  StatisticsPercentDirective
];

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [directives],
  exports: [directives]
})
export class BookrawSharedDirectivesModule {}
